import gql from 'graphql-tag'
import { EnumFields } from '..'

export const AppraisalResponseTypeFragment = gql`
  fragment AppraisalResponseType on purchase_appraisal_response_type {
    ${EnumFields}
  }
`
